import React from 'react';

import { omit } from 'lodash';

export function PopperComponent(props) {
  return <div {...omit(props, ['disablePortal', 'anchorEl', 'open', 'style'])} />;
}
